import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserStore } from 'src/app/shared/services/user/user.state';

export const integrationsEnabledGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (!userStore.integrationsEnabled()) {
    router.navigate(['/crm/contacts']);
    return false;
  }
  return true;
};
